import { createGlobalStyle } from 'styled-components';

const size = {
  small: '770px',
  medium: '1220px',
  large: '1700px',
};

const colors = {
  primary: '#FFDA4F',
  success: '#20C239',
  warning: '#FACA22',
  danger: '#FF1717',
  white: '#FFFFFF',
  black: '#000000',
  lightGray: '#EBEBEB',
  lineGray: '#F2F2F2',
  gray: '#d9d9d9',
  darkGray: '#7F7F7F',
  lightYellow: '#ffda4f80',
  orange: '#FFC83A',
  lightOrange: '#ffcd50',
  blue: '#0077d7',
  green: '#00ae0099',
  yellow: '#f8cc5e',
  antBlue: '#40a9ff',
};

const theme = {
  ...colors,
  colors,
  mobile: `(max-width: ${size.small})`,
  tablet: `(max-width: ${size.medium})`,
  laptop: `(max-width: 1440px)`,
  desktop: `(max-width: ${size.large})`,
};

const GlobalStyle = createGlobalStyle`

  body {
    margin: 0;
    padding: 0;
    overflow-y: scroll;
    background-color: ${(props) => props.theme.colors.white};
  }

  a, a:link, a:visited, a:focus {
    color: #000000;
    text-decoration: none;
    font-weight: 400;
  }

  a:hover {
    color: ${(props) => props.theme.colors.darkGray};
  }

  a,
  a:link,
  a:hover,
  a:active,
  a:visited {
    -webkit-transition: none !important;
    -moz-transition: none !important;
    -o-transition: none !important;
    transition: none !important;
  }

  /* input[type="text"], */
  input[type="password"],
  input[type="email"] {
    width: 100%;
    height: auto; // 높이 초기화
    line-height: normal; // line-height 초기화
    border-radius: 0;
    outline: none;
    outline-style: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  button,
  input[type="submit"],
  input[type="button"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    box-shadow: none;
    border: none;
    outline: 0;
    cursor: pointer;
    text-align: center;
    text-decoration: none;
  }

  /* button:active,
  button:hover,
  button:focus,
  input[type="submit"]:active,
  input[type="submit"]:hover,
  input[type="submit"]:focus,
  input[type="button"]:active,
  input[type="button"]:hover,
  input[type="button"]:focus {
    background-color: ${(props) => props.theme.colors.blue};
    outline: 0;
  } */

  .ant-popover.ant-popover-placement-bottom  {
    left: 141px !important;
    top: 172px !important;
  }

  .ant-popover-placement-bottom > .ant-popover-content > .ant-popover-arrow {
    left: 54%;
    transform: translateX(-50%) rotate(45deg);
  }

  div.ant-popover-content > div.ant-popover-arrow {
    border: 1px solid ${(props) => props.theme.colors.gray};
    background-color: #ffffff !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    border-top-color: ${(props) => props.theme.colors.gray} !important;
    border-left-color: ${(props) => props.theme.colors.gray} !important;
    box-shadow: none !important;
    top: 4px !important;
  }

  .ant-popover-arrow {
    width: 12px !important;
    height: 12px !important;
  }

  .ant-popover-placement-leftBottom > .ant-popover-content > .ant-popover-arrow  {
    transform: translateY(350%) rotate(45deg);
    border-top-color: ${(props) => props.theme.colors.white} !important;
    border-left-color: ${(props) => props.theme.colors.white} !important;
  }

  .ant-popover-inner {
    box-shadow: none;
    border: 1px solid ${(props) => props.theme.colors.gray};
    border-radius: 0.5em;
  }

  .ant-popover-inner-content {
    padding: 0;
  }

  .ant-drawer-body > a,
  .ant-drawer-body > a:link,
  .ant-drawer-body > a:focus,
  .ant-drawer-body > a:visited {
    color: ${(props) => props.theme.colors.white};
    font-size: 17px;
    font-family: 'Noto Sans KR', sans-serif;
    font-weight: 300;
    margin-bottom: 15px;
  }

  .ant-tooltip-inner {
    box-shadow: none;
    background-color: ${(props) => props.theme.colors.darkGray};
  }

  /* .ant-table-filter-dropdown {
    width: 200px;
    .ant-dropdown-menu-item {
      font-size: 12px;
      padding: 3px 12px;
    }
  } */

  .ant-btn-sm {
    font-size: 12px;
  }

  .ant-select-item-option-content {
    font-size: 0.9em;
    margin-left: 0.35em;
    :hover {
      /* font-weight: 600; */
      color: ${(props) => props.theme.colors.blue};
      background-color: ${(props) => props.theme.colors.white};
    }
  }

  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    color: ${(props) => props.theme.colors.blue};
    font-weight: 500;
  }

  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
    background-color: ${(props) => props.theme.colors.white};
  }

  .row-dragging {
    background: transparent;
  }

  .row-dragging td {
    font-size: 0.85em;
    background: transparent;
    visibility: hidden;
  }

  .row-dragging .drag-visible {
    visibility: visible;
  }

  .ant-modal-content > .ant-modal-close {
    background-color: transparent;
  }
  .ant-popover-placement-bottom, .ant-popover-placement-bottomLeft, .ant-popover-placement-bottomRight{
    position: fixed;
  }
  .ant-input-number-input-wrap,.ant-input-number, .ant-input-number-input {
    transition: none;
  }
  .ant-input-number-input-wrap,.ant-input-number, .ant-input-number-input ,.ant-tabs > .ant-tabs-nav .ant-tabs-nav-list,.ant-tabs-tab-btn,.ant-btn{
    transition: none;
  }
  .react-datepicker-wrapper {
    display: inline-block;
    padding: 0;
    border: 0;
    width: 200px;
  }
`;

export { theme, GlobalStyle };
